import {
  Box,
  Container,
  Grid,
  Typography,
  Link,
  Stack,
  Divider,
} from '@mui/material';

import PhoneIcon from '@mui/icons-material/Phone';
import EmailIcon from '@mui/icons-material/Email';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import { appConfig } from '../configs/app-config';
import SocialIcons from './SocialIcons';

export default function Footer() {
  return (
    <Box
      sx={{
        backgroundColor: 'primary.dark',
        color: '#fff',
        mt: 6,
        pt: 6,
        pb: 3,
      }}
    >
      <Container>

        {/* ================= MAIN GRID ================= */}
        <Grid container spacing={4}>

          {/* -------- 1. BRAND INFO -------- */}
          <Grid item xs={12} sm={6} md={3}>
            <Typography variant="h6" fontWeight={600} mb={2}>
              {appConfig.appName}
            </Typography>

            <Typography variant="body2" color="#e0e0e0">
              Supplying premium quality herbs, spices, and oils with
              purity, authenticity, and trust.
            </Typography>

            <Typography mt={2} fontSize={13}>
              🌿 Certified Purity. Trusted Quality.
            </Typography>
          </Grid>

          {/* -------- 2. QUICK LINKS -------- */}
          <Grid item xs={12} sm={6} md={3}>
            <Typography variant="h6" fontWeight={600} mb={2}>
              Quick Links
            </Typography>

            <Stack spacing={1}>
              <Link href="/" color="#e0e0e0" underline="none">
                Home
              </Link>
              <Link href="/products/herbs-spices" color="#e0e0e0" underline="none">
                Products
              </Link>
              <Link href="/about" color="#e0e0e0" underline="none">
                About Us
              </Link>
              <Link href="/contact" color="#e0e0e0" underline="none">
                Contact Us
              </Link>
            </Stack>
          </Grid>

          {/* -------- 3. WORKING HOURS -------- */}
          <Grid item xs={12} sm={6} md={3}>
            <Typography variant="h6" fontWeight={600} mb={2}>
              Working Hours
            </Typography>

            <Typography color="#e0e0e0">
              Monday – Saturday
            </Typography>
            <Typography color="#e0e0e0" mb={1}>
              9:00 AM – 7:00 PM
            </Typography>

            <Typography color="#e0e0e0">
              Sunday: Closed
            </Typography>
          </Grid>

          {/* -------- 4. CONTACT DETAILS -------- */}
          <Grid item xs={12} sm={6} md={3}>
            <Typography variant="h6" fontWeight={600} mb={2}>
              Contact
            </Typography>

            <Stack spacing={1.5}>

              <Stack direction="row" spacing={1} alignItems="center">
                <PhoneIcon fontSize="small" />
                <Typography variant="body2">
                {appConfig.appAuthorPhone}
                </Typography>
              </Stack>
              <Stack direction="row" spacing={1} alignItems="center">
                <PhoneIcon fontSize="small" />
                <Typography variant="body2">
                {appConfig.secodaryContactNumber}
                </Typography>
              </Stack>

              <Stack direction="row" spacing={1} alignItems="center">
                <EmailIcon fontSize="small" />
                <Typography variant="body2">
                {appConfig.appAuthorEmail}
                </Typography>
              </Stack>

              <Stack direction="row" spacing={1} alignItems="flex-start">
                <LocationOnIcon fontSize="small" />
                <Typography variant="body2">
                  {appConfig.appAuthorAddress}
                </Typography>
              </Stack>

            </Stack>
          </Grid>

        </Grid>

        {/* ================= DIVIDER ================= */}
        <Divider sx={{ my: 4, backgroundColor: 'rgba(255,255,255,0.2)' }} />

        {/* ================= BOTTOM ================= */}
        <Box
          sx={{
            textAlign: 'center',
            fontSize: 14,
            color: '#ccc',
          }}
        >

          <SocialIcons variant="footer" sx={{ mb: 1, justifyContent: 'center' }} />

          {/* COPYRIGHT */}
          © {new Date().getFullYear()} {appConfig.appName}. All rights reserved.

        </Box>

      </Container>
    </Box>
  );
}